<template>
  <div class="container">
    <div v-if="$route.fullPath !== '/'">
      <a @click="goBack($route.path)"
        ><img
          class="cross"
          alt="cross"
          style="width: 22px; height: 22px; margin: 0"
          src="../assets/images/back.svg"
      /></a>
    </div>
    <div v-else>
      <img
        class="cross"
        alt="cross"
        style="width: 22px; height: 22px; margin: 0"
        src="../assets/images/arrow-back.svg"
      />
    </div>
    <img
      class="logo"
      alt="aigm logo"
      src="../assets/logo.png"
      @click="$router.push('/')"
    />
    <div v-if="isMobile()">
      <a href="cmd://webview-close">
        <img class="cross" alt="cross" src="../assets/images/cross.svg"
      /></a>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  computed: {
    ...mapGetters("Algo1Module", ["getMyQuestions", "getArrow"]),
  },
  methods: {
    goBack(url) {
      this.clearState();
      this.clearState4();
      const temp = url.split("/");
      temp.splice(temp.length - 1, 1);
      if (temp.length > 1) {
        // means current level is deeper than the first level
        this.$router.push(`${temp.join("/")}`); // redirect to previous level
      } // means previous level is home
      else {
        this.$router.push("/"); // redirect to home
        this.resetArrow();
      }
    },
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },

    ...mapActions("Algo1Module", ["clearState", "resetArrow"]),
    ...mapActions("Algo4Module", ["clearState4"]),
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/scss/variables/mixin.scss";
@import "@/assets/styles/scss/variables/colors.scss";

.container {
  display: flex;
  justify-content: space-between;
  background-color: $light-pink;
  border-bottom-left-radius: 17px;
  border-bottom-right-radius: 17px;
  height: 90px;
  align-items: center;
  padding: 0 30px;
  box-shadow: 0px 3px 6px #00000029;
  .logo {
    width: 55px;
  }
  a {
    img {
      width: 22px;
      height: 22px;
    }
  }
}
</style>
